export default __webpack_public_path__ + "static/media/dashboard-automation.69ade2d4.svg";